import {IActionModel} from "../../shared/models/action.model";
import {
    SET_ACCOUNT_EXECUTIVE_LIST,
    SET_ACCOUNT_PREFERENCES,
    SET_ALL_LOCATION_LIST_LITE,
    SET_BILLING_MODE_LIST,
    SET_CITY_LIST_LITE,
    SET_ETHNICITY_LIST,
    SET_FACILITY_LIST_LITE,
    SET_FACILITY_STATUS,
    SET_FACILITY_TYPES,
    SET_INSURANCE_COMPANY_LIST,
    SET_INSURANCE_PLAN_LIST,
    SET_LAB_LIST_LITE,
    SET_LAB_STATUS,
    SET_LOCATION_LIST_LITE,
    SET_LOCATION_STATUS,
    SET_PANEL_CODE_LIST,
    SET_PAYOR_MIX_LIST,
    SET_PHYSICIAN_LIST_LITE,
    SET_RACE_LIST,
    SET_RELATION_SHIP_LIST,
    SET_SAMPLE_STATUS_LIST,
    SET_SAMPLE_TYPES_LIST,
    SET_TEST_ORDER_STATUS,
    SET_TEST_PANEL_STATUS,
    SET_USER_LIST,
    SET_EQUIPMENT_TYPE_LIST,
    SET_TEST_PANEL_LIST,
    SET_SAMPLE_COLLECTION_DEVICE_LIST,
    SET_REPORT_TYPE_LIST,
    SET_TEST_LIST_LITE,
    SET_EXPRESSIONS_LIST_LITE,
    SET_BIOMARKER_LIST,
    SET_AGE_LIST,
    SET_SYSTEM_CONFIG,
    GET_SYSTEM_CONFIG,
    SET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES,
    SET_PREFIX_LIST,
    SET_SUFFIX_LIST,
    SET_MARITAL_STATUS_LIST, SET_MODULE_PRIMARY_ATTACHMENT
} from "../actions/staticData.action";
import {ModulePrimaryAttachment} from "../../shared/models/static-data.model";

export interface SystemConfigTypes {
    id?: number;
    title?: string;
    billingReportHeaders?: {
        id: string;
        title: string;
    }[];
    logo?: {
        url: string;
    };
    miniLogo?: {
        url: string;
    };
    labConfiguration?: {
        name: string;
    },
    createdAt?: string;
    updatedAt?: string;

}

export interface IStaticDataReducerState {
    insuranceCompanyList: any[];
    insurancePlanList: any[];
    relationShipList: any[];
    ethnicityList: any[];
    raceList: any[];
    facilityTypesList: any[];
    userList: any[];
    payorMixList: any[];
    accountPreferenceList: any;
    facilityListLite: any[];
    locationListLite: any[];
    allLocationListLite: any[];
    labListLite: any[];
    labStatusList: any[];
    facilityStatusList: any[];
    locationStatusList: any[];
    testOrderStatusList: any[];
    testPanelStatusList: any[];
    physicianListLite: any[];
    citiesListLite: any[];
    sampleStatusList: any[];
    sampleTypesList: any[];
    reportTypeList: any[];
    sampleCollectionDeviceNameList: any[];
    panelCodeList: any[];
    billingModeList: any[];
    accountExecutiveList: any[];
    equipmentTypeList: any[];
    testPanelList: any[];
    testListLite: any[];
    expressionsListLite: any[];
    biomarkerList: any[];
    ageList: any[];
    roleList: any[];
    prefixList: any[];
    suffixList: any[];
    maritalStatusList: any[];
    systemConfig: {
        isLoading: boolean,
        data?: SystemConfigTypes
    };
    modulePrimaryAttachment: ModulePrimaryAttachment;
    sampleTypeWithCollectionDevices: any[];
}

const INITIAL_STATE: IStaticDataReducerState = {
    insuranceCompanyList: [],
    insurancePlanList: [],
    relationShipList: [],
    ethnicityList: [],
    raceList: [],
    facilityTypesList: [],
    reportTypeList: [],
    userList: [],
    payorMixList: [],
    sampleCollectionDeviceNameList: [],
    accountPreferenceList: {},
    facilityListLite: [],
    locationListLite: [],
    allLocationListLite: [],
    labListLite: [],
    labStatusList: [],
    facilityStatusList: [],
    locationStatusList: [],
    testOrderStatusList: [],
    testPanelStatusList: [],
    physicianListLite: [],
    citiesListLite: [],
    sampleStatusList: [],
    sampleTypesList: [],
    panelCodeList: [],
    billingModeList: [],
    accountExecutiveList: [],
    equipmentTypeList: [],
    testPanelList: [],
    testListLite: [],
    expressionsListLite: [],
    biomarkerList: [],
    ageList: [],
    roleList: [],
    prefixList: [],
    suffixList: [],
    maritalStatusList: [],
    systemConfig: {
        isLoading: false,
    },
    modulePrimaryAttachment: {},
    sampleTypeWithCollectionDevices: [],
};

const staticDataReducer = (state: IStaticDataReducerState = INITIAL_STATE, action: IActionModel): IStaticDataReducerState => {
    switch (action.type) {
        case SET_INSURANCE_COMPANY_LIST:
            return {
                ...state,
                insuranceCompanyList: action.payload,
            };

        case SET_INSURANCE_PLAN_LIST:
            return {
                ...state,
                insurancePlanList: action.payload,
            };


        case SET_RELATION_SHIP_LIST:
            return {
                ...state,
                relationShipList: action.payload,
            };

        case SET_ETHNICITY_LIST:
            return {
                ...state,
                ethnicityList: action.payload,
            };


        case SET_RACE_LIST:
            return {
                ...state,
                raceList: action.payload,
            };

        case SET_FACILITY_TYPES:
            return {
                ...state,
                facilityTypesList: action.payload,
            }

        case SET_USER_LIST:
            return {
                ...state,
                userList: action.payload,
            }

        case SET_ACCOUNT_EXECUTIVE_LIST:
            return {
                ...state,
                accountExecutiveList: action.payload,
            }

        case SET_PAYOR_MIX_LIST:
            return {
                ...state,
                payorMixList: action.payload,
            }

        case SET_ACCOUNT_PREFERENCES:
            return {
                ...state,
                accountPreferenceList: action.payload
            }

        case SET_FACILITY_LIST_LITE:
            return {
                ...state,
                facilityListLite: action.payload
            }

        case SET_LOCATION_LIST_LITE:
            return {
                ...state,
                locationListLite: action.payload
            }
        case SET_ALL_LOCATION_LIST_LITE:
            return {
                ...state,
                allLocationListLite: action.payload
            }

        case SET_LAB_LIST_LITE:
            return {
                ...state,
                labListLite: action.payload
            }
        case SET_LAB_STATUS:
            return {
                ...state,
                labStatusList: action.payload
            }

        case SET_FACILITY_STATUS:
            return {
                ...state,
                facilityStatusList: action.payload
            }

        case SET_LOCATION_STATUS:
            return {
                ...state,
                locationStatusList: action.payload
            }

        case SET_TEST_ORDER_STATUS:
            return {
                ...state,
                testOrderStatusList: action.payload
            }

        case SET_TEST_PANEL_STATUS:
            return {
                ...state,
                testPanelStatusList: action.payload
            }

        case SET_PHYSICIAN_LIST_LITE:
            return {
                ...state,
                physicianListLite: action.payload
            }

        case SET_CITY_LIST_LITE:
            return {
                ...state,
                citiesListLite: action.payload
            }
        case SET_SAMPLE_STATUS_LIST:
            return {
                ...state,
                sampleStatusList: action.payload
            }
        case SET_SAMPLE_TYPES_LIST:
            return {
                ...state,
                sampleTypesList: action.payload
            }
        case SET_PANEL_CODE_LIST:
            return {
                ...state,
                panelCodeList: action.payload
            }
        case SET_BILLING_MODE_LIST:
            return {
                ...state,
                billingModeList: action.payload
            }
        case SET_EQUIPMENT_TYPE_LIST:
            return {
                ...state,
                equipmentTypeList: action.payload
            };
        case SET_TEST_PANEL_LIST:
            return {
                ...state,
                testPanelList: action.payload
            }
        case SET_SAMPLE_COLLECTION_DEVICE_LIST:
            return {
                ...state,
                sampleCollectionDeviceNameList: action.payload
            }
        case SET_REPORT_TYPE_LIST:
            return {
                ...state,
                reportTypeList: action.payload
            }
        case SET_TEST_LIST_LITE:
            return {
                ...state,
                testListLite: action.payload
            }
        case SET_EXPRESSIONS_LIST_LITE:
            return {
                ...state,
                expressionsListLite: action.payload
            }
        case SET_BIOMARKER_LIST:
            return {
                ...state,
                biomarkerList: action.payload
            }
        case SET_AGE_LIST:
            return {
                ...state,
                ageList: action.payload
            }
        case 'SET_ROLE_LIST':
            return {
                ...state,
                roleList: action.payload
            }
        case GET_SYSTEM_CONFIG:
            return {
                ...state,
                systemConfig: {
                    ...state.systemConfig,
                    isLoading: true,
                }
            }
        case SET_SYSTEM_CONFIG:
            return {
                ...state,
                systemConfig: {
                    ...state.systemConfig,
                    data: action.payload,
                    isLoading: false,
                }
            }
        case SET_SAMPLE_TYPES_WITH_COLLECTION_DEVICES:
            return {
                ...state,
                sampleTypeWithCollectionDevices: action.payload,
            }
        case SET_PREFIX_LIST:
            return {
                ...state,
                prefixList: action.payload,
            }
        case SET_SUFFIX_LIST:
            return {
                ...state,
                suffixList: action.payload,
            }
        case SET_MARITAL_STATUS_LIST:
            return {
                ...state,
                maritalStatusList: action.payload,
            }
        case SET_MODULE_PRIMARY_ATTACHMENT:
            return {
                ...state,
                modulePrimaryAttachment: action.payload,
            }
        default:
            return state;
    }
};

export default staticDataReducer;
